import { runWithErrorReporting } from "$root/api/error-reporting/report";
import { platformToast } from "$root/notification-system/toast";
import { ToastableError } from "$root/utils";

export function updateAclWithFeedbacks(asyncAclUpdate: () => Promise<void>, params?: { multi?: boolean}) {
	return runWithErrorReporting(
		async () => {
			try {
				await asyncAclUpdate();
				platformToast({
					children: params?.multi ? "Permissions updated successfully" : "Permission updated successfully",
					severity: "success",
					icon: "Portfolio",
				});
			} catch (err) {
				throw new ToastableError("Something went wrong while updating the permission", {
					cause: err,
					icon: "Portfolio",
				});
			}
		},
		{
			area: "user",
			attemptedOperation: {
				message: `change ACL in area`,
			},
		},
	);
}

